import { Stack, SvgIconProps, Typography } from '@mui/material'
import { PropsWithChildren } from 'react'

import { Organism, OrganismFrame } from '@/core/architecture'

type ResaleItemProps = PropsWithChildren<{
  title: string
  Icon?: (props: SvgIconProps) => JSX.Element
}>

export const ResaleItem: Organism<ResaleItemProps> = ({
  children,
  title,
  Icon,
}) => (
  <OrganismFrame>
    <Stack spacing={3} sx={{ pb: 8 }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ bgcolor: 'grey.50', py: 1, px: 2 }}
      >
        {Icon && <Icon fontSize="small" sx={{ color: 'grey.600' }} />}
        <Typography variant="h6" color="text.secondary">
          {title}
        </Typography>
      </Stack>
      {children}
    </Stack>
  </OrganismFrame>
)
